import {
    CHANGE_SHOWS_FREQUENCY_CUSTOM_PERIOD,
    CHANGE_SHOWS_FREQUENCY_LIMIT,
    CHANGE_SHOWS_FREQUENCY_PERIOD_PRESET,
    INIT_SHOWS_FREQUENCY_EDITORS,
    ShowsFrequencyActions,
    TOGGLE_SHOWS_FREQUENCY,
    VALIDATE_SHOWS_FREQUENCY_CUSTOM_PERIOD,
    VALIDATE_SHOWS_FREQUENCY_LIMIT
} from '../actions/showsFrequency';
import {
    validateCustomPeriod,
    validateShowsLimit
} from '../service/ShowsFrequencyEditorHelpers/ShowsFrequencyEditorHelpers';
import { ShowsFrequencyEditorState, ShowsFrequencyPeriodPreset } from '../typings/showsFrequency';
import { State } from '../typings/state';

export const showsFrequencyInitialState = {
    isActive: false,
    showsLimit: '',
    periodPreset: ShowsFrequencyPeriodPreset.Period,
    customPeriod: ''
};

export function showsFrequencyEditor(
    state: ShowsFrequencyEditorState = {},
    action: ShowsFrequencyActions,
    fullState: State
): ShowsFrequencyEditorState {
    switch (action.type) {
        case INIT_SHOWS_FREQUENCY_EDITORS: {
            return action.initData.reduce((acc, editorData) => {
                return {
                    ...acc,
                    [editorData.editorId]: {
                        ...showsFrequencyInitialState,
                        isActive: editorData.isActive,
                        showsLimit: editorData.showsLimit,
                        periodPreset: editorData.periodPreset,
                        customPeriod: editorData.customPeriod
                    }
                };
            }, {});
        }

        case TOGGLE_SHOWS_FREQUENCY: {
            const newIsActiveValue = !state[action.editorId].isActive;
            const newState = newIsActiveValue ? state[action.editorId] : showsFrequencyInitialState;

            return {
                ...state,
                [action.editorId]: {
                    ...newState,
                    isActive: newIsActiveValue
                }
            };
        }

        case CHANGE_SHOWS_FREQUENCY_LIMIT: {
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    showsLimit: action.showsLimit
                }
            };
        }

        case VALIDATE_SHOWS_FREQUENCY_LIMIT: {
            const showsLimit = state[action.editorId].showsLimit;

            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    showsLimitErrors: validateShowsLimit(showsLimit)
                }
            };
        }

        case CHANGE_SHOWS_FREQUENCY_PERIOD_PRESET: {
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    periodPreset: action.periodPreset
                }
            };
        }

        case CHANGE_SHOWS_FREQUENCY_CUSTOM_PERIOD: {
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    customPeriod: action.customPeriod
                }
            };
        }

        case VALIDATE_SHOWS_FREQUENCY_CUSTOM_PERIOD: {
            const customPeriod = state[action.editorId].customPeriod;

            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    customPeriodErrors: validateCustomPeriod(customPeriod)
                }
            };
        }

        default:
            return state;
    }
}
